<template>
  <w-sliding-popup ref="slidingPopup" :title="titleName" @close="closePopup" width="1000px">
    <div slot="content">
      <w-trouble-ticket ref="troubleTicketList" :active="isActive" viewType="kedbPopup"></w-trouble-ticket>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="saveTroubleTicketInfo">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import WTroubleTicket from '@/views/event/trouble-ticket';

export default {
  name: 'WRelationTroubleTicketPopup',
  components: {
    WTroubleTicket,
  },
  data() {
    return {
      titleName: '연관 장애티켓 추가',
      isActive: false,
    };
  },
  methods: {
    close() {
      this.$refs.slidingPopup.visible = false;
      this.closePopup();
    },
    closePopup() {
      this.isActive = false;
      this.$refs.troubleTicketList.resetSearchCondition();
      this.$refs.troubleTicketList.$refs.searchField.clear();
      this.$refs.troubleTicketList.troubleShootingDetailShow = false;
      this.$refs.troubleTicketList.$refs.troubleTicketTable.$children[0].clearSelection();
    },
    open() {
      this.$refs.slidingPopup.open();
      this.isActive = true;
    },
    /**
     * 추가한 장애티켓을 KEDB 추가/수정 팝업의 연관 장애티켓 목록에 추가한다.
     * @author yelim
     */
    saveTroubleTicketInfo() {
      const selectTicketList = this.$refs.troubleTicketList.selectionTickets;
      this.$emit('selection-ticket', selectTicketList);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/popup/RelationTroubleTicketPopup.vue